import BlogThirtyFiveContainer from "./container/BlogThirtyFiveContainer";
export default BlogThirtyFiveContainer;
